// extracted by mini-css-extract-plugin
module.exports = {"link":"SSOButton_link__GGnBX","container":"SSOButton_container__1tXuq","image":"SSOButton_image__Uw81a","text":"SSOButton_text__3-6qv"};